import styled from 'styled-components';
import { Image } from '../../components/raw-components/image/image';

//game-info-icon
export const GameIconDefaultBox = styled(Image)`
    display: block;
    background-size: 100%;
    background-image: url("${props => props.theme.images.singleGame.defaultBackgroundImage.toString()}");
    background-repeat: no-repeat;
`;

